export function isCustomerCancelableOption(option) {
  if (!option) return false;
  if (option.type === "deposit") return false;
  if (option.state === "사용함") return false;
  return true;
}

export function getCancelUnavailableReason(option) {
  if (!option) return "";
  if (option.type === "deposit") return "보증금 옵션은 여기서 취소할 수 없습니다.";
  if (option.state === "사용함") return "이미 사용한 옵션입니다.";
  return "";
}

function toPositiveInteger(value) {
  const parsed = Number.parseInt(value, 10);
  if (!Number.isFinite(parsed) || parsed < 1) return 0;
  return parsed;
}

function toPrice(value) {
  const parsed = Number.parseInt(value, 10);
  if (!Number.isFinite(parsed)) return 0;
  return parsed;
}

export function getSelectedAddOptions(optionProducts, quantitiesByOptionId, reservId) {
  if (!Array.isArray(optionProducts)) return [];

  return optionProducts
    .map((option) => {
      const quantity = toPositiveInteger(quantitiesByOptionId?.[option.id]);
      if (!quantity) return null;

      return {
        reservId,
        optionId: option.id,
        name: option.name,
        price: toPrice(option.price),
        quantity,
        taxfree: Boolean(option.tax_free),
        type: option.type || "",
      };
    })
    .filter(Boolean);
}

export function calculateAddOptionsTotal(addOptions) {
  if (!Array.isArray(addOptions)) return 0;
  return addOptions.reduce((sum, option) => {
    return sum + toPrice(option.price) * toPositiveInteger(option.quantity);
  }, 0);
}

export function calculateCancelOptionsTotal(existingOptions, selectedOptionIds) {
  if (!Array.isArray(existingOptions) || !Array.isArray(selectedOptionIds)) return 0;
  const selectedIds = new Set(selectedOptionIds.map(String));
  return existingOptions.reduce((sum, option) => {
    if (!selectedIds.has(String(option.id))) return sum;
    return sum + toPrice(option.price);
  }, 0);
}
